import React from 'react'

import Helmet from 'react-helmet'
import Intro from '../components/Intro'
import ProductFilter from '../components/ProductFilter'
import ProductOverview from '../components/ProductOverview'
import Paragraph from '../components/Paragraph'
import AboutSection from '../components/AboutSection'
import TextBlock from '../components/TextBlock'
import OrderForm from './OrderForm'

const HomeContent = ({ data }) => {
  const sitename = data.site.siteMetadata.title
  const { labels } = data
  return (
    <div>
      <Intro labels={data.labels} sitename={sitename} />
      <span id="about" />
      <AboutSection data={data.about} />
      <span id="products" />
      <ProductOverview labels={data.labels} data={data.products} />
      <span id="maintenance" />
      <TextBlock
        multi
        data={data.maintenance}
        number="03"
        numberTitle={labels.strings.maintenance_section_title}
        blockTitle={labels.strings.maintenance_section_sub_title}
      />
      <TextBlock
        leader
        flipped
        scrollTarget="#filter"
        data={data.intern}
        number="04"
        numberTitle={labels.strings.how_to_section_title}
        blockTitle={labels.strings.how_to_section_sub_title}
      />
      <span id="filter" />
      <ProductFilter
        title={labels.strings.product_filter_title}
        fresh_label={labels.strings.product_filter_cat_fresh}
        persistent_label={labels.strings.product_filter_cat_persistent}
        product_categories={data.productCategories.categories}
        order_label={labels.strings.order_button_label}
        main_placeholder_label={
          labels.strings.product_filter_main_cat_placeholder
        }
        sub_placeholder_label={
          labels.strings.product_filter_sub_cat_placeholder
        }
        water_disclaimer={labels.strings.product_filter_water_disclaimer}
        dynamic_product_title={labels.strings.product_filter_dynamic_title}
        id="filter"
        data={data.products}
      />
      <span id="contact" />
      <Paragraph data={data.questions} />
      <OrderForm countries={data.countries} />
    </div>
  )
}

export default HomeContent



// WEBPACK FOOTER //
// ./src/components/HomeContent.js